import React, {useState} from 'react';  
import { Button } from 'react-bootstrap';
import { FaArrowUp } from "react-icons/fa";
  
const BackToTopButton = () =>{ 
  
  const [visible, setVisible] = useState(false) 
  
  const toggleVisible = () => { 
    const scrolled = document.documentElement.scrollTop; 
    if (scrolled > 200){ 
      setVisible(true) 
    }  
    else if (scrolled <= 200){ 
      setVisible(false) 
    } 
  }; 
  
  const scrollToTop = () =>{ 
    window.scrollTo({ 
      top: -50,  
      behavior: 'smooth'
    }); 
  }; 
  
  window.addEventListener('scroll', toggleVisible); 
  
  return ( 
    <Button className='backtotop'> 
     <FaArrowUp onClick={scrollToTop}  
     style={{display: visible ? 'inline' : 'none'}} /> 
    </Button> 
  ); 
} 
  
export default BackToTopButton; 
